export default __webpack_public_path__ + "static/media/titleicon3.06d8de5e.svg";